import { twMerge } from "tailwind-merge";
import Button from "../button";
import { ModalPortal } from "src/containers/modal-portal";

const ModalHeader = ({ title, onClose = () => {} }: any) => {
  return (
    <>
      <div className="flex justify-between items-center px-6 py-5 rounded-t-lg ">
        <div>
          <div className="text-lg">{title}</div>
        </div>
        <div className="flex gap-5 cursor-pointer" onClick={onClose}>
          &#10005;
        </div>
      </div>
      <hr />
    </>
  );
};

const ModalFooter = ({
  onClose = () => {},
  onSave = () => {},
  noTitle,
  yesTitle,
}: any) => {
  return (
    <div className="flex items-center justify-end p-3 border-t border-solid border-slate-200 rounded-b-lg bg-gray-100 gap-4">
      <Button size="large" outlined onClick={onClose}>
        {noTitle}
      </Button>
      <Button size="large" onClick={onSave}>
        {yesTitle}
      </Button>
    </div>
  );
};

const Modal = ({
  title,
  children,
  footer,
  onClose = () => {},
  onSave = () => {},
  size = "small",
  header,
  noTitle = "Close",
  yesTitle = "Save",
  noFooter = false,
}: any) => {
  const className = [""];
  if (size === "large") {
    className.push("w-[75vw]");
  } else if (size === "medium") {
    className.push("w-[50vw]");
  } else if (size === "small") {
    className.push("w-[30vw] min-w-[400px]");
  }

  return (
    <ModalPortal>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-auto my-6 mx-auto">
          <div
            className={twMerge(
              "border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[300px]",
              className.join(" "),
            )}
          >
            {header ? (
              <>{header}</>
            ) : (
              title && <ModalHeader title={title} onClose={onClose} />
            )}
            {/* <ModalHeader title={title} {...header} onClose={onClose} /> */}

            <div
              className={`relative p-6 flex-auto max-h-[90vh] overflow-auto ${
                footer ? "" : "rounded-b-lg"
              }`}
            >
              {children}
            </div>
            {noFooter ? null : footer ? (
              <div className="flex items-center justify-end p-3  border-t border-solid border-slate-200 rounded-b-lg bg-gray-100 gap-4">
                {footer}
              </div>
            ) : (
              <ModalFooter
                onClose={onClose}
                onSave={onSave}
                noTitle={noTitle}
                yesTitle={yesTitle}
              />
            )}
          </div>
        </div>
      </div>
      <div className="opacity-60 fixed inset-0 z-40 bg-black"></div>
    </ModalPortal>
  );
};

export default Modal;
